import React from 'react';

import { DeliveryTime } from '~api/api';

import { useTranslate } from '~src/main/context/localization';
import { formatDeliveryTime } from './delivery-time-formatters';
import { useGlobalState } from '../context/global-state';

interface DeliveryTimeComponentProps {
  deliveryTime: DeliveryTime;
}

export const DeliveryTimeComponent: React.FC<DeliveryTimeComponentProps> = ({ deliveryTime }) => {
  const globalState = useGlobalState();
  const tICU = useTranslate();

  return (
    <span>
      {formatDeliveryTime(tICU, deliveryTime, {
        showDeliveryTimeAsEstimate: !!globalState.flags.show_delivery_times_as_estimates,
      })}
    </span>
  );
};
